import { render } from "./CarByPerson.vue?vue&type=template&id=6486b982"
import script from "./CarByPerson.vue?vue&type=script&lang=js"
export * from "./CarByPerson.vue?vue&type=script&lang=js"

import "./CarByPerson.vue?vue&type=style&index=0&id=6486b982&lang=scss"

import exportComponent from "F:\\work\\git\\yunchi\\yc-vue-source\\yunman\\node_modules\\.store\\vue-loader@16.8.3\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__